import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { buildLocalizedPathname, resolveContentLanguage } from 'utils/localePath';

const useLocalePath = () => {
  const location = useLocation();
  const locale = resolveContentLanguage(location.pathname);

  return useCallback(
    (path, targetLocale = locale) => {
      const normalizedPath = path.startsWith('/') ? path : `/${path}`;
      return buildLocalizedPathname(normalizedPath, targetLocale);
    },
    [locale],
  );
};

export default useLocalePath;
